import { useFormikContext } from "formik";
import { EntityProfileIndustry } from "@common/types/entity";
import { Picker } from "@design-system/Picker/Picker.lib";
import { FormikField } from "@components/forms/FormikField/FormikField";
import {
    getIndustryLabel,
    industryItems,
    industryPickerItems,
} from "../constants";
import { getMultiSelectTriggerValue } from "../lib";
import fieldSpacing from "./fieldSpacing.module.scss";

interface Props {
    industriesFieldName: string;
    industryOtherFieldName: string;
    label?: string;
    optional?: boolean;
    triggerClassName?: string;
}

export const IndustryPicker = ({
    industriesFieldName,
    industryOtherFieldName,
    label = "Industry",
    optional,
    triggerClassName = "mb-1",
}: Props) => {
    const { setFieldValue } = useFormikContext();

    return (
        <FormikField<EntityProfileIndustry[]>
            name={industriesFieldName}
            label={label}
            optional={optional}
            control="button"
            className={fieldSpacing.buttonField}
        >
            {({ helpers, field, invalid }) => (
                <Picker.Select
                    multiple
                    searchable
                    searchPlaceholder="Search..."
                    emptyLabel="No matching industries"
                    items={industryPickerItems}
                    value={field.value ?? []}
                    onOpenChange={(open) => {
                        if (!open) {
                            helpers.setTouched(true);
                        }
                    }}
                    onValueChange={(selectedIndustries) => {
                        if (
                            !selectedIndustries.includes(
                                EntityProfileIndustry.OTHER,
                            )
                        ) {
                            setFieldValue(industryOtherFieldName, "");
                        }

                        helpers.setValue(selectedIndustries);
                    }}
                    renderValue={(selectedIndustries) =>
                        getMultiSelectTriggerValue(
                            [...selectedIndustries],
                            industryItems.length,
                            getIndustryLabel,
                        )
                    }
                    placeholder="Select"
                    aria-invalid={invalid}
                    trigger={
                        <Picker.Button
                            variant="primary"
                            size="xl"
                            block
                            className={triggerClassName}
                        />
                    }
                />
            )}
        </FormikField>
    );
};
